module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He was never sure if the cold influenced him. It should be the opposite. That as the ground grew more unyielding and the air frigid he would sleep better. It just didn’t work that way.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Odd.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("There were fewer of them this time of year. It didn’t really matter—it just was. Each month had a certain draw. Perhaps that was why he was so hungry. He had to work for it this time of year.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The summer was too easy. He’d done the summer first, but there really was no challenge in it. June. July, August, September.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Even October had been child’s play.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The woods were quiet, sleeping, waiting, full of shadows.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Perfect.")])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The car sat")]), _vm._v(" there, tucked into the side of the road between two white pines on a level spot, nose into the shadows, carefully parked in the turnoff, all windows up. Detective Ellie MacIntosh walked past it twice, a full circle, the empty windows not talking to her. No movement inside, no signs of violence, the patches of frost on the windshield starred with symmetrical snowflake crystals. Autumn leaves tickled her ankles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was absurd, but she’d taken her gun out. She didn’t even realize it until she lowered the weapon, her breath leaving her lungs in an audible exhale. “There’s no one visible in the vehicle. Try not to touch anything that might give us fingerprints, but open the trunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, ma’am.” To his credit, the county officer who had called in the abandoned car didn’t point out he’d already told her that no one was visible inside. He instead nodded at another officer and between them they took a crowbar and went to work. In the meantime, several other law enforcement vehicles had arrived, the meandering curve on the remote road taking on color and movement, the naked trunks of the trees reflecting the swirling blue lights.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’d hoped … Well, she’d just "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("hoped")]), _vm._v(" this call hadn’t been the one they were waiting for, because if it was … ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It meant it had happened again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The wrench of metal screamed, the trunk popped open, and the two officers peered inside. One of them said, “Detective? Want to take a look at this?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ellie took two steps and stared into the trunk. Did she want to look? No, she sure as hell didn’t. Whatever was in there, she didn’t want to see it. Her palms were damp and hot despite the cold; her heart pounding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The plain interior held a blanket and a flare for emergencies. There was also an atlas with a torn cover.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She muttered hoarsely, “That bastard.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6631d670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0